export default class TutorialManager {
  constructor() {
    this.storageKeyPrefix = 'a11y-tutorial-seen-';
    this.tutorials = {
      // --- AI & Advanced ---
      aiVision: {
        title: 'Opis obrazków (AI)',
        steps: ['1. Znajdź obrazek.', '2. Kliknij w niego.', '3. Posłuchaj opisu.'],
        icon: 'ai', demoClass: 'a11y-demo-click'
      },
      textSimplifier: {
        title: 'Wyjaśnij tekst (AI)',
        steps: ['1. Znajdź trudny tekst.', '2. Kliknij w niego.', '3. Przeczytaj opis.'],
        icon: 'ai', demoClass: 'a11y-demo-text'
      },
      smartNavigation: {
        title: 'Inteligentna nawigacja',
        steps: ['1. Włącz funkcję.', '2. Naciśnij klawisz TAB.', '3. Wybierz skrót.'],
        icon: 'ai', demoClass: 'a11y-demo-nav'
      },
      textToSpeech: {
        title: 'Czytaj na głos',
        steps: ['1. Wybierz tekst.', '2. Kliknij go.', '3. Słuchaj lektora.'],
        icon: 'text-to-speech', demoClass: 'a11y-demo-speak'
      },
      
      // --- Text Adjustments ---
      fontSize: {
        title: 'Rozmiar tekstu',
        steps: ['1. Wybierz poziom.', '2. Tekst się powiększy.', '3. Czytaj wygodniej.'],
        icon: 'font-size', demoClass: 'a11y-demo-text-size'
      },
      lineHeight: {
        title: 'Odstępy linii',
        steps: ['1. Wybierz odstęp.', '2. Linie się odsuną.', '3. Tekst jest przejrzystszy.'],
        icon: 'line-height', demoClass: 'a11y-demo-spacing'
      },
      letterSpacing: {
        title: 'Odstępy liter',
        steps: ['1. Wybierz szerokość.', '2. Litery się odsuną.', '3. Łatwiej składać słowa.'],
        icon: 'letter-spacing', demoClass: 'a11y-demo-spacing'
      },
      dyslexicFont: {
        title: 'Czcionka dyslektyczna',
        steps: ['1. Włącz opcję.', '2. Czcionka się zmieni.', '3. Litery są wyraźniejsze.'],
        icon: 'dyslexic-font', demoClass: 'a11y-demo-font'
      },
      
      // --- Content & Reading ---
      highlightLinks: {
        title: 'Podświetl linki',
        steps: ['1. Włącz opcję.', '2. Linki będą żółte.', '3. Łatwo je zauważysz.'],
        icon: 'highlight-links', demoClass: 'a11y-demo-links'
      },
      readingPacer: {
        title: 'Tempo czytania',
        steps: ['1. Ustal prędkość.', '2. Pasek prowadzi wzrok.', '3. Czytaj płynnie.'],
        icon: 'reading-pacer', demoClass: 'a11y-demo-pacer'
      },
      bionicReading: {
        title: 'Bionic Reading',
        steps: ['1. Włącz tryb.', '2. Początki słów są pogrubione.', '3. Mózg szybciej czyta.'],
        icon: 'bionic-reading', demoClass: 'a11y-demo-text'
      },
      contentChunking: {
        title: 'Podział treści',
        steps: ['1. Włącz tryb.', '2. Długi tekst znika.', '3. Czytaj akapit po akapicie.'],
        icon: 'content-chunking', demoClass: 'a11y-demo-text'
      },

      // --- Contrast & Display ---
      contrast: {
        title: 'Kontrast',
        steps: ['1. Wybierz tryb.', '2. Kolory się zmienią.', '3. Tekst jest czytelniejszy.'],
        icon: 'contrast', demoClass: 'a11y-demo-contrast'
      },
      invert: {
        title: 'Odwróć kolory',
        steps: ['1. Włącz inwersję.', '2. Jasne stanie się ciemnym.', '3. Mniej męczy wzrok.'],
        icon: 'invert', demoClass: 'a11y-demo-invert'
      },
      saturation: {
        title: 'Nasycenie',
        steps: ['1. Wybierz poziom.', '2. Kolory zbledną.', '3. Mniej bodźców.'],
        icon: 'saturation', demoClass: 'a11y-demo-saturation'
      },
      colorBlindness: {
        title: 'Daltonizm',
        steps: ['1. Wybierz swój typ.', '2. Kolory się dostosują.', '3. Lepiej je rozróżnisz.'],
        icon: 'color-blindness', demoClass: 'a11y-demo-contrast'
      },
      hideImages: {
        title: 'Ukryj obrazy',
        steps: ['1. Włącz funkcję.', '2. Obrazki znikną.', '3. Skup się na tekście.'],
        icon: 'hide-images', demoClass: 'a11y-demo-images'
      },

      // --- Navigation & Focus ---
      largeCursor: {
        title: 'Duży kursor',
        steps: ['1. Włącz kursor.', '2. Będzie ogromny.', '3. Łatwo go znajdziesz.'],
        icon: 'large-cursor', demoClass: 'a11y-demo-cursor-big'
      },
      magnifier: {
        title: 'Lupa',
        steps: ['1. Ruszaj myszką.', '2. Lupa powiększy treść.', '3. Dostrzeżesz detale.'],
        icon: 'magnifier', demoClass: 'a11y-demo-magnifier'
      },
      readingWindow: {
         title: 'Wirtualne okno',
         steps: ['1. Ruszaj myszką.', '2. Reszta jest ciemna.', '3. Skup się na pasku.'],
         icon: 'virtual-window', demoClass: 'a11y-demo-window'
      },
      semanticOverlay: {
         title: 'Struktura strony',
         steps: ['1. Włącz opcję.', '2. Zobaczysz nagłówki.', '3. Zrozumiesz budowę.'],
         icon: 'semantic-overlay', demoClass: 'a11y-demo-structure'
      },
      focusPath: {
         title: 'Ścieżka fokusa',
         steps: ['1. Użyj Tab.', '2. Linia pokaże ruch.', '3. Nie zgubisz się.'],
         icon: 'focus-path', demoClass: 'a11y-demo-path'
      },
      delayedHover: {
         title: 'Opóźnienie',
         steps: ['1. Najedź na element.', '2. Poczekaj chwilę.', '3. Unikniesz błędów.'],
         icon: 'delayed-hover', demoClass: 'a11y-demo-timer'
      },
      disableAnimations: {
         title: 'Stop animacjim',
         steps: ['1. Włącz opcję.', '2. Ruch ustanie.', '3. Spokojniejszy widok.'],
         icon: 'disable-animations', demoClass: 'a11y-demo-pause'
      },
      autoScroll: {
         title: 'Autoprzewijanie',
         steps: ['1. Włącz przewijanie.', '2. Strona płynie.', '3. Nie musisz klikać.'],
         icon: 'auto-scroll', demoClass: 'a11y-demo-scroll'
      }
    };
  }

  show(featureKey) {
    if (!this.tutorials[featureKey]) return;
    if (this.hasSeen(featureKey)) return;

    this.renderModal(featureKey);
    this.markAsSeen(featureKey);
  }

  hasSeen(featureKey) {
    return localStorage.getItem(this.storageKeyPrefix + featureKey) === 'true';
  }

  markAsSeen(featureKey) {
    localStorage.setItem(this.storageKeyPrefix + featureKey, 'true');
  }

  renderModal(featureKey) {
    const data = this.tutorials[featureKey];
    
    // Remove existing if any
    const existing = document.getElementById('a11y-tutorial-modal');
    if (existing) existing.remove();

    const modal = document.createElement('div');
    modal.id = 'a11y-tutorial-modal';
    modal.className = 'a11y-tutorial-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    
    const stepsHtml = data.steps.map((step, index) => 
        `<div class="a11y-tutorial-step" style="animation-delay: ${index * 0.5}s">${step}</div>`
    ).join('');

    modal.innerHTML = `
      <div class="a11y-tutorial-content">
        <div class="a11y-tutorial-header">
            <div class="a11y-tutorial-icon a11y-icon a11y-icon--${data.icon}"></div>
            <h3 class="a11y-tutorial-title">${data.title}</h3>
        </div>
        
        <div class="a11y-tutorial-body">
            <div class="a11y-tutorial-steps">
                ${stepsHtml}
            </div>
            <div class="a11y-tutorial-demo ${data.demoClass}">
                <div class="a11y-demo-cursor"></div>
                <div class="a11y-demo-element"></div>
            </div>
        </div>

        <button class="a11y-tutorial-btn js-a11y-tutorial-close">Rozumiem, dzięki!</button>
      </div>
    `;

    document.body.appendChild(modal);

    // Focus management could be added here
    const btn = modal.querySelector('.js-a11y-tutorial-close');
    btn.focus();

    btn.addEventListener('click', () => {
      modal.remove();
    });
  }
}
